import classNames from "classnames";
import { PhosphorLock, PhosphorUsersThree, PhosphorWarning } from "components/Atoms/PhosphorIcon";
import React from "react";
import { joinWithMaxLength } from "shared/utils/stringutils";

const MAX_VISIBLE_PEOPLE = 3;

interface PurpleHeaderPeopleRowProps {
  artistName: string | undefined
  contactNames: string[]
  locked?: boolean
  notValidated?: boolean
}

export const PurpleHeaderPeopleRow = ({ artistName, contactNames, locked, notValidated }: PurpleHeaderPeopleRowProps) => {
  const joinedContactNames = joinWithMaxLength(contactNames, ", ", MAX_VISIBLE_PEOPLE);

  return <div>
    <div className="purple-header-people-row">
      <div className={classNames("purple-header-people-artist", { "purple-header-light": !artistName })}>
        <PhosphorUsersThree iconColor="white" />
        <span className="purple-header-text">{artistName || RESX.Artist.NoArtistSet}</span>
      </div>
      {locked && <PhosphorLock iconColor="white" iconSize="large" />}
      {notValidated && <PhosphorWarning iconColor="white" iconSize="large" />}
    </div>
    {joinedContactNames && <div className="purple-header-text purple-header-light purple-header-contacts">{joinedContactNames}</div>}
  </div>;
};
